'use client';
import NextImage, { ImageProps } from 'next/legacy/image';
import ErrorBoundary from '../ErrorBoundary';
import imageLoader from '../../utils/imageLoader';

export const Image = (props: ImageProps) => {
  const src = props.src as string;
  const isAmplienceImage =
    src?.startsWith?.('https://i8.amplience.net') ||
    src?.startsWith?.('https://cdn.media.amplience.net');

  // For layout="fill" images without sizes, provide a sensible default
  // This prevents Next.js warnings while maintaining visual appearance
  const layoutFillSizes = props.layout === 'fill' && !props.sizes ? '100vw' : props.sizes;

  // Destructure to prevent sizes override
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { sizes: _sizes, ...restProps } = props;

  return (
    <ErrorBoundary>
      <NextImage
        {...restProps}
        sizes={layoutFillSizes}
        loader={isAmplienceImage ? imageLoader : undefined}
      />
    </ErrorBoundary>
  );
};

export default Image;
